import { render } from "./Dependents.vue?vue&type=template&id=3391aee0"
import script from "./Dependents.vue?vue&type=script&lang=js"
export * from "./Dependents.vue?vue&type=script&lang=js"

import exportComponent from "G:\\deploy\\cfan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__